// removed by extract-text-webpack-plugin
module.exports = {"carousel-container":"_3r1SV","container":"H2Vno","body":"UXOYM","carousel":"_6clw3","slide":"_14_-a","dots":"_2lfyy","dot":"MWrvF","dot-active":"_2qWfJ MWrvF","navigation":"_13UUO","next":"_23Vt9 _13UUO","previous":"_4IotD _13UUO","sr-only":"UTI64","sr-only-focusable":"_3OKWK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FeaturedCarousel.less
// module id = ./src/components/Home/FeaturedCarousel.less
// module chunks = 2